/**
 * Error response DTO.
 * Synchronized with backend GlobalExceptionHandler error format.
 */
export class ErrorResponse {
  constructor(data = {}) {
    this.status = data.status || 'error';
    this.timestamp = data.timestamp || new Date().toISOString();
    this.error = {
      code: data.error?.code || 'UNKNOWN_ERROR',
      message: data.error?.message || 'An unexpected error occurred',
      details: data.error?.details || null
    };
  }

  /**
   * Gets user-friendly error message.
   */
  getUserMessage() {
    switch (this.error.code) {
      case 'BAD_CREDENTIALS':
        return 'Invalid email or password. Please try again.';
      case 'ACCOUNT_DISABLED':
        return 'Your account has been disabled. Please contact support.';
      case 'VALIDATION_ERROR':
        return this.getValidationMessage();
      case 'NETWORK_ERROR':
        return 'Unable to connect to the server. Please check your internet connection.';
      default:
        return this.error.message || 'An unexpected error occurred. Please try again.';
    }
  }

  /**
   * Gets validation error message from details.
   */
  getValidationMessage() {
    if (this.error.details) {
      const messages = Object.values(this.error.details);
      return messages.join(', ');
    }
    return 'Please check your input and try again.';
  }

  /**
   * Creates ErrorResponse from API error or network error.
   */
  static fromError(error) {
    if (error.response) {
      // Backend returned an error response
      return new ErrorResponse(error.response.data);
    } else if (error.request) {
      // Network error - no response received
      return new ErrorResponse({
        error: {
          code: 'NETWORK_ERROR',
          message: 'Unable to connect to the server'
        }
      });
    } else {
      // Something else happened
      return new ErrorResponse({
        error: {
          code: 'CLIENT_ERROR',
          message: error.message || 'An unexpected error occurred'
        }
      });
    }
  }
}
